module.exports = __webpack_public_path__ + "static/jest-9a03f8dc3c5e73007cf68c20718b3462.png";